import React, { Component } from 'react';
import './Status.css';

class Status extends Component {
	render() {
		return (
			<div id="status"
					 className={
					 	(this.props.blink ? 'blink ' : ' ') +
					 	(this.props.light ? 'light ' : '')
					 }>
				<div className="status-label">{this.props.status}</div>
			</div>
		);
	}
}

export default Status;


// WEBPACK FOOTER //
// ./src/Status.js